Vue.component('ack-home', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-home',
	mixins: [languageMixins],

	mounted() {
		appLog.log('ack-home mounted');

		if (this.showMainSlider) {
			this.getSlideList(this.mainSliderId).then(() => {
				this.sliders[this.mainSliderId] = this.slidersLists[this.mainSliderId];
			});
		}
		this.startHomeBannerCarousel();
	},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
	},
	computed: {
		...Vuex.mapGetters(['isMobile']),
		...Vuex.mapGetters('sliders', ['slidersLists']),
		...Vuex.mapGetters('articles', ['articlesArray']),
		lastArticles() {
			let arr = [];
			for (let index = 0; index < 3; index++) {
				const element = this.articlesArray[index];
				arr.push(element);
			}
			return arr;
		},
		mainSliderSlides() {
			return this.sliders[this.mainSliderId];
		},
		isMobile() {
			return this.$parent.isMobile;
		},
		testimonials() {
			return [
				{
					title: 'Efficient 3D Printing',
					rate: 5,
					content:
						'Implementing 3D printing into our restorative workflow was so easy with the Ackuretta SOL SE printer, CLEANI and CURIE Plus. We are printing surgical guides, occlusal guards, crowns, models, all on x prototypes, provisionals and more. I love its small footprint too.',
					authorImg: window.ackShopifyFileUrl('KOL_Testimonials_Susan_McMahon.jpg'),
					authorName: 'Dr. Susan McMahon',
				},
				{
					title: 'Rodin RapidCeram',
					rate: 5,
					content:
						'As a power user of 3D printing in clinical practice we are enjoying using Rodin RapidCeram for everything from full arch hybrids to single crowns. Rodin RapidCeram prints faster on our existing equipment allowing us to increase productivity without additional capital expenditure or workflow disruption.',
					authorImg: window.ackShopifyFileUrl(
						'KOL_Testimonials_-Rick_Ferguson_45be003f-ca7b-4b2b-b628-f5f327842a6d.jpg',
					),
					authorName: 'Dr. Rick Ferguson DMD, DABOI/ID,DICOI',
				},
				{
					title: 'Rodin Glaze N2 Free',
					rate: 5,
					content:
						'Glaze N₂-Free has been one of my favorite product releases of 2025. It\u2019s so easy to apply and can be used extraorally and intraorally, making it a versatile material. For anyone doing printed dentures or restorations, it\u2019s a must have in the kit!',
					authorImg: window.ackShopifyFileUrl('Andrew_Ip_1.jpg'),
					authorName: 'Dr. Andrew IP, BDS, GDP, JCU, IMC, IDDA',
				},
			];
		},
	},
	data() {
		return {
			pageId: 'home-page',
			mainSliderId: 'main-slider',
			showMainSlider: false,
			activeHomeBannerIndex: 0,
			homeBannerInterval: null,
			homeBannerAutoplaySpeed: 5000,
			homeBannerSlides: [
				{
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Website_home_banner_1.jpg?v=1782454060',
					mobileImage:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Website_home_banner_Phone_1.jpg?v=1782454079',
					link: '/products/rodin-chroma-flash',
					alt: 'Ackuretta website home banner 1',
				},
				{
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Website_home_banner_2.jpg?v=1782454067',
					mobileImage:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Website_home_banner_Phone_2.jpg?v=1782454085',
					link: '/products/sol-plus-high-volume-dental-3d-printer',
					alt: 'Ackuretta website home banner 2',
				},
				{
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Website_home_banner_3.jpg?v=1782454073',
					mobileImage:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Website_home_banner_Phone_3.jpg?v=1782454092',
					link: '/products/sol-se-dental-3d-printer',
					buttonText: 'Read the Press Release',
					buttonUrl: '/blogs/press-releases/pacdent-acquires-ackuretta',
					alt: 'Ackuretta website home banner 3',
				},
				{
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Website_home_banner_4.jpg?v=1782454079',
					mobileImage:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Website_home_banner_Phone_4.jpg?v=1782454093',
					link: '/products/n2-free-palette-naturalizing-kit',
					alt: 'Ackuretta website home banner 4',
				},
			],
			sliders: {
				'main-slider': null,
			},
			carouselOptions: {
				arrows: false,
				dots: false,
				infinite: true,
				slidesToShow: 5,
				slidesToScroll: 1,
				autoplay: true,
				speed: 3000,
				autoplaySpeed: 0,
				cssEase: 'linear',
			},
			articles: null,
			banner_section: {
				title: 'Less Stress, More Success, We Got You Covered',
				url_image: '/pages/ackuretta-concierge',
				image:
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Concierge_Page_Home_page_banner.jpg?v=1782357072',
				imgAlt: 'Concierge_Page_Home_page_banner',
			},
			partnersLogos: [
				{
					name: '3Shape',
					logo: window.ackShopifyFileUrl('Home_V4_3shape.png'),
				},
				{
					name: 'Exocad',
					logo: window.ackShopifyFileUrl('Home_V4_Exocad.png'),
				},
				{
					name: 'Medit',
					logo: window.ackShopifyFileUrl('Home_V4_Medit.png'),
				},
				{
					name: 'Argen',
					logo: window.ackShopifyFileUrl('Home_V4_Argen.png'),
				},
				{
					name: 'BEGO',
					logo: window.ackShopifyFileUrl('Home_V4_Bego.png'),
				},
				{
					name: 'Dentona',
					logo: window.ackShopifyFileUrl('Home_V4_Dentona.png'),
				},
				{
					name: 'Keystone',
					logo: window.ackShopifyFileUrl('Home_V4_Keystone.png'),
				},
				{
					name: 'PacDent',
					logo: window.ackShopifyFileUrl('Home_V4_Pac-dent.png'),
				},
				{
					name: 'Next Dent',
					logo: window.ackShopifyFileUrl('Home_V4_Nextdent.png'),
				},
				{
					name: 'VOCO',
					logo: window.ackShopifyFileUrl('voco.png'),
				},
			],
		};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		...Vuex.mapActions('sliders', ['getSlideList']),
		showNextHomeBanner() {
			if (this.homeBannerSlides.length < 2) return;
			this.activeHomeBannerIndex = (this.activeHomeBannerIndex + 1) % this.homeBannerSlides.length;
		},
		setHomeBanner(index) {
			this.activeHomeBannerIndex = index;
			this.startHomeBannerCarousel();
		},
		startHomeBannerCarousel() {
			this.stopHomeBannerCarousel();
			if (this.homeBannerSlides.length < 2) return;
			this.homeBannerInterval = window.setInterval(
				this.showNextHomeBanner,
				this.homeBannerAutoplaySpeed,
			);
		},
		stopHomeBannerCarousel() {
			if (this.homeBannerInterval == null) return;
			window.clearInterval(this.homeBannerInterval);
			this.homeBannerInterval = null;
		},
	},
	beforeDestroy() {
		this.stopHomeBannerCarousel();
	},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
